import axios from 'axios'
import { MDBNavItem, MDBNavbar, MDBNavbarNav } from 'mdbreact'
import React, { useEffect, useState } from 'react'
import ImagenDescargar from '../../../../paginas/img/bluemoon/apps.png'
import ImagenStripe from '../../../../paginas/img/bluemoon/medios.png'
import { faInstagram } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationDot, faLocationPin, faPhone } from '@fortawesome/free-solid-svg-icons'
import Image from './Image'

const ruta = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API + 'paginas/'


const Footer = (props) => {
    const { direccionFooter, instagramFooter, telefonoFooter } = props?.styles;
    const [items, setItems] = useState([])
    useEffect(() => {
        const obtenerMenu = async () => {
            try {
                const { data } = await axios(ruta, { params: { menu: true } })
                if (!data) return setItems([])
                setItems(data)
            } catch (error) {
                console.log(error)
            }
        }
        obtenerMenu()
    }, [])

    return (
        <div className='footer-container'>
            <div className='footer row'>
                <div className='footer_item footer-image-container col-md'>
                    <Image {...props} className='footer-image' />
                </div>
                <div className='footer_item col-md'>
                    <div className='container'>
                        <MDBNavbarNav>
                            {items && items.map(nav => (
                                <MDBNavItem key={nav.id}>
                                    <a className="nav-link waves-effect waves-light" to="#!">{nav.nombre}</a>
                                </MDBNavItem>
                            ))}
                            <MDBNavItem>
                                <a className="nav-link waves-effect waves-light" to="#!">Descarga la App</a>
                            </MDBNavItem>
                        </MDBNavbarNav>
                        <img src={ImagenDescargar} className='footer-descargar' />
                    </div>

                </div>
                <div className='footer_item col-md'>
                    <div className='container'>
                        <p className='nav-link'>Contácto </p>
                        <MDBNavbarNav right >
                            <MDBNavItem className="mr-4 font-weight-bold">
                                <FontAwesomeIcon icon={faLocationDot} />
                                <span> {direccionFooter}</span>
                            </MDBNavItem>
                            <MDBNavItem className="mr-4 font-weight-bold" >
                                <FontAwesomeIcon icon={faPhone} />
                                <span> Info {telefonoFooter}</span>
                            </MDBNavItem>
                            <MDBNavItem className="mr-4 font-weight-bold" >
                                <FontAwesomeIcon icon={faInstagram} />
                                <span> Info {instagramFooter}</span>
                            </MDBNavItem>
                        </MDBNavbarNav>
                        <img src={ImagenStripe} className='footer-stripe' />
                    </div>

                </div>
            </div>
            <div className='footer-derechos'>
                Todos los derechos reservados © copyrigth 2023 - Desarrollado por Técnosoluciones Agencia
            </div>
        </div>
    )
}

export default Footer